import { useEffect, useState } from "react";
import useVehiclesQuery from "../api/use-vehicles-query";
import { ResponseSelector, VehicleData, VehiclesResponse } from "../types";
import { useDealersStore } from "./use-dealers-store";

export const useVehiclesStore = () => {
  const { isSuccess, localDealer } = useDealersStore();

  const [ dealerVehicles, setDealerVehicles ] = useState<VehicleData[]>();
  const [ regularVehicles, setRegularVehicles ] = useState<VehicleData[]>();
  const [ vehicleSetsReady, setVehicleSetsReady ] = useState(false);

  const getVehicles: ResponseSelector<VehiclesResponse, VehicleData[]> = res => res?.data;
  const { isLoading, data: vehicles } = useVehiclesQuery<VehiclesResponse, VehicleData[]>({select: getVehicles});

  const getSingleVehicle = (vinOrId: string) => {
    const vehicle = (vehicles as VehicleData[])?.find(vehicle => vehicle.vin === vinOrId || String(vehicle.id) === vinOrId);
    return vehicle;
  };

  useEffect(() => {
    if (!!(vehicles as VehicleData[]) && isSuccess) {
      setDealerVehicles((vehicles as VehicleData[])?.filter(vehicle => vehicle.dealer_id === localDealer?.static_dealer_id));
      setRegularVehicles((vehicles as VehicleData[])?.filter(vehicle => vehicle.dealer_id !== localDealer?.static_dealer_id));

      setVehicleSetsReady(true);
    }
  }, [vehicles, isSuccess])

  return {
    isLoading,
    isSuccess,
    vehicleSetsReady,
    dealerVehicles,
    regularVehicles,
    getSingleVehicle
  };
};
